export const ZULAUF = "NR_1";
export const NOTABLAUF_VORKLAERUNG = "NR_2";
export const ABLAUF_VORKLAERUNG = "NR_3";
export const ZULAUF_1_BIOL_STUFE = "NR_4";
export const ZULAUF_2_BIOL_STUFE = "NR_5";
export const ABLAUF_KUEHLWASSER = "NR_6";
export const ABLAUF_NACHKLAERUNG = "NR_7";
export const EINLEITUNGSSTELLE = "NR_8";
export const ENDKONTROLLMESSSTELLE = "NR_12";
export const SONSTIGE = "NR_13";
export const EINLEITSTELLE_MISCHWASSERANLAGE = "NR_14";
export const EINLEITSTELLE_NIEDERSCHLAGSWASSERANLAGE = "NR_15";
export const SONDE_BECKEN = "NR_20";
export const SONDE_BECKENUEBERLAUF = "NR_21";
export const SONDE_KLAERUEBERLAUF = "NR_22";
export const SONDE_ABLAUF = "NR_23";
export const SONDE_PUMPWERK = "NR_24";
export const EINLEITSTELLE_BECKENUEBERLAUF = "NR_25";
export const EINLEITSTELLE_BODENFILTER = "NR_26";
export const EINLEITSTELLE_GRUNDWASSER = "NR_27";
export const EINLEITSTELLE_KLAERUEBERLAUF = "NR_28";
export const EINLEITSTELLE_NOTENTLASTUNG = "NR_29";
export const EINLEITSTELLE_REGENRUECKHALTEBECKEN = "NR_30";

export function messstellentypIdToObj(id) {
    switch (id) {
        case ZULAUF:
            return { id: ZULAUF, value: "Zulauf" };
        case NOTABLAUF_VORKLAERUNG:
            return { id: NOTABLAUF_VORKLAERUNG, value: "Notablauf Vorklärung" };
        case ABLAUF_VORKLAERUNG:
            return { id: ABLAUF_VORKLAERUNG, value: "Ablauf Vorklärung" };
        case ZULAUF_1_BIOL_STUFE:
            return { id: ZULAUF_1_BIOL_STUFE, value: "Zulauf 1. Biol. Stufe" };
        case ZULAUF_2_BIOL_STUFE:
            return { id: ZULAUF_2_BIOL_STUFE, value: "Zulauf 2. Biol. Stufe" };
        case ABLAUF_KUEHLWASSER:
            return { id: ABLAUF_KUEHLWASSER, value: "Ablauf Kühlwasser" };
        case ABLAUF_NACHKLAERUNG:
            return { id: ABLAUF_NACHKLAERUNG, value: "Ablauf Nachklärung" };
        case EINLEITUNGSSTELLE:
            return { id: EINLEITUNGSSTELLE, value: "Einleitungsstelle" };
        case ENDKONTROLLMESSSTELLE:
            return { id: ENDKONTROLLMESSSTELLE, value: "Endkontrollmessstelle" };
        case SONSTIGE:
            return { id: SONSTIGE, value: "Sonstige" };
        case EINLEITSTELLE_MISCHWASSERANLAGE:
            return { id: EINLEITSTELLE_MISCHWASSERANLAGE, value: "Einleitstelle Mischwasseranlage" };
        case EINLEITSTELLE_NIEDERSCHLAGSWASSERANLAGE:
            return { id: EINLEITSTELLE_NIEDERSCHLAGSWASSERANLAGE, value: "Einleitstelle  Niederschlagswasseranlage" };
        case SONDE_BECKEN:
            return { id: SONDE_BECKEN, value: "Sonde Becken" };
        case SONDE_BECKENUEBERLAUF:
            return { id: SONDE_BECKENUEBERLAUF, value: "Sonde Beckenüberlauf" };
        case SONDE_KLAERUEBERLAUF:
            return { id: SONDE_KLAERUEBERLAUF, value: "Sonde Klärüberlauf" };
        case SONDE_ABLAUF:
            return { id: SONDE_ABLAUF, value: "Sonde Ablauf" };
        case SONDE_PUMPWERK:
            return { id: SONDE_PUMPWERK, value: "Sonde Pumpwerk" };
        case EINLEITSTELLE_BECKENUEBERLAUF:
            return { id: EINLEITSTELLE_BECKENUEBERLAUF, value: "Einleitstelle Beckenüberlauf" };
        case EINLEITSTELLE_BODENFILTER:
            return { id: EINLEITSTELLE_BODENFILTER, value: "Einleitstelle Bodenfilter" };
        case EINLEITSTELLE_GRUNDWASSER:
            return { id: EINLEITSTELLE_GRUNDWASSER, value: "Einleitstelle Grundwasser" };
        case EINLEITSTELLE_KLAERUEBERLAUF:
            return { id: EINLEITSTELLE_KLAERUEBERLAUF, value: "Einleitstelle Klärüberlauf" };
        case EINLEITSTELLE_NOTENTLASTUNG:
            return { id: EINLEITSTELLE_NOTENTLASTUNG, value: "Einleitstelle Notentlastung" };
        case EINLEITSTELLE_REGENRUECKHALTEBECKEN:
            return { id: EINLEITSTELLE_REGENRUECKHALTEBECKEN, value: "Einleitstelle Regenrückhaltebecken" };
        default:
            return null;
    }
}
